import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MaintenanceHistorySubmitDto, MaintenanceHistoryDto } from 'src/app/models/maintenance-history/maintenance-history.model';
import { AuthService } from '../../authentication/auth.service';
import { BaseApiService } from '../../base-api.service';
import { TranslateFirebaseService } from '../../utils/translate-firebase.service';

@Injectable()
export class RestMaintenanceHistoryService extends BaseApiService {

  constructor(
    httpClient: HttpClient,
    translate: TranslateFirebaseService,
    private authService: AuthService
  ) {
    super(httpClient, translate);
  }

  /**
   * POST /MaintenanceHistory
   * Creates a new maintenance history record
   */
  createMaintenanceHistory(submitDto: MaintenanceHistorySubmitDto): Observable<MaintenanceHistoryDto> {
    return this.httpClient.post<MaintenanceHistoryDto>(
      super.getUpsApiHost() + 'MaintenanceHistory',
      submitDto,
      { headers: this.authService.upsHttpHeaders }
    );
  }

  /**
   * GET /MaintenanceHistory/{id}
   * Retrieves a maintenance history by ID
   */
  getMaintenanceHistoryById(id: number): Observable<MaintenanceHistoryDto> {
    return this.httpClient.get<MaintenanceHistoryDto>(
      super.getUpsApiHost() + 'MaintenanceHistory/' + id,
      { headers: this.authService.upsHttpHeaders }
    );
  }

  /**
   * GET /MaintenanceHistory/user/{userId}
   * Retrieves maintenance histories by user ID
   */
  getMaintenanceHistoriesByUserId(userId: number): Observable<MaintenanceHistoryDto[]> {
    return this.httpClient.get<MaintenanceHistoryDto[]>(
      super.getUpsApiHost() + 'MaintenanceHistory/user/' + userId,
      { headers: this.authService.upsHttpHeaders }
    );
  }

  /**
   * GET /MaintenanceHistory/serialNumber/{serialNumberId}/{maintenanceId}/last
   * Retrieves the last maintenance history for a specific serial number and maintenance
   */
  getLastMaintenanceHistory(serialNumberId: number, maintenanceId: number): Observable<MaintenanceHistoryDto> {
    return this.httpClient.get<MaintenanceHistoryDto>(
      super.getUpsApiHost() + `MaintenanceHistory/serialNumber/${serialNumberId}/${maintenanceId}/last`,
      { headers: this.authService.upsHttpHeaders }
    );
  }
}
